// extracted by mini-css-extract-plugin
export var divider = "_p7-0";
export var systemMessage = "_p7-1";